import React, { useEffect, useState } from "react";
import { apiGet, apiPost } from "api/callApi";
import { Button, DetailDrawer, Loader } from "InnoUI/components";
import InnoIcons from "InnoUI/innoicons";
import UserProjectDropdown from "components/UserProjectDropDown";
import theme from "theme";
import SC from "./style";
import OccupantList from "./OccupantList";
import EmptyPage from "components/EmptyPage";
import AssignUser from "views/AdminSettings/Projects/AssignUser";
import { showAlert } from "utils/helper/index.js";
import LevelDropdown from "components/LevelDropdown";

function AssignOccupant(props) {
  const {
    onClose = () => {},
    userdata,
    setOpenAssignProjectDrawer,
    setCurrentPage,
    fetchData = () => {},
    defaultProject = null,
    addressBook = false,
  } = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]); // Project level data
  const [selectedItems, setSelectedItems] = useState([]);
  const [userProjectId, setUserProjectId] = useState(defaultProject);
  const [occupantCount, setOccupantCount] = useState(0);
  const [userProjectDropdownData, setUserProjectDropdownData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedLevel, setSelectedLevel] = useState(null);
  const [rootLibraryAccess, setRootLibraryAccess] = useState(false);

  const [openAssignUserDrawer, setopenAssignUserDrawer] = useState(false);

  useEffect(() => {
    if (defaultProject) {
      setUserProjectId(defaultProject);
      setUserProjectId(defaultProject);
      getLevels(defaultProject);
      getUserAssignOccupants(defaultProject);
    }
  }, [defaultProject]);

  const closeAssignUserDrawer = () => {
    setopenAssignUserDrawer(false);
    onClose();
    setTimeout(() => {
      setOpenAssignProjectDrawer(true);
    }, 500);
  };

  const handleProjectChange = (selectedProject) => {
    setUserProjectId(selectedProject);
    getLevels(selectedProject);
    getUserAssignOccupants(selectedProject);
  };
  // Fetch project levels (get level options)
  const getLevels = async (selectedProject) => {
    try {
      setLoading(true);
      const response = await apiGet(
        `/v1/getleveloptions/${selectedProject}`,
        false,
      );
      setData(response.data);
      setLoading(false);
      setOccupantCount(response?.occupantCount || 0);
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };

  const getUserAssignOccupants = async (projectId) => {
    try {
      setLoading(true);
      const response = await apiGet(
        `/v1/assignoccupant/${userdata.id}/${projectId}`,
        false,
      );
      const assignedoccupants = response.data.map(
        (occupant) => occupant.occupantId,
      );
      setSelectedItems(assignedoccupants);
      setRootLibraryAccess(response?.rootLibraryAccess == 1);
      setLoading(false);
    } catch (error) {
      console.log("error", error);
      setRootLibraryAccess(false);
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value.toLowerCase().trim());
  };

  // Manage role assignment
  const manageUserOccupants = async () => {
    if (!userProjectId) {
      showAlert({
        title: "Please select a project",
        text: "You need to choose a project first",
        icon: "warning",
      });

      return;
    }
    try {
      setLoading(true);
      const response = await apiPost(`/v1/assignoccupant/${userdata.id}`, {
        occupants: selectedItems,
        projectId: userProjectId,
        rootLibraryAccess: rootLibraryAccess ? 1 : 0,
      });
      // setData(response?.data || []);
      showAlert({ title: "Success", text: response?.message, icon: "success" });
      setLoading(false);
      onClose();
      await fetchData();
      if (setCurrentPage) {
        setCurrentPage(1);
      }
    } catch (error) {
      showAlert({
        title: "Error",
        text: error?.response?.data?.message,
        icon: "error",
      });

      setLoading(false);
      setData([]);
    }
  };

  const handleChangeLevel = (value, id) => {
    setSelectedLevel(id); // assuming `value` is the selected level's unique identifier
  };

  const filterData = selectedLevel
    ? data.filter((level) => level.id == selectedLevel)
    : data;

  return (
    <>
      <SC.DrawerTitlesContainer>
        <SC.DrawerTitles>
          Manage Project to {userdata?.fullName || "user"}
        </SC.DrawerTitles>
        <SC.CloseIcon>
          <InnoIcons.CloseIcon onClick={onClose} />
        </SC.CloseIcon>
      </SC.DrawerTitlesContainer>

      {loading && <Loader />}

      <div
        style={{
          padding: "20px",
          display: "flex",
          justifyContent: "space-between",
          display: "flex",
          alignItems: "center",
        }}
      >
        <UserProjectDropdown
          onChange={handleProjectChange}
          userId={userdata.id}
          setUserProjectDropdownData={setUserProjectDropdownData}
          defaultValue={userProjectId}
          disabledDropdown={addressBook}
        />

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <SC.ButtonContainer>
            <Button
              caption="Cancel"
              fontSize="12px"
              style={{
                background: "#f7f9f7",
                color: theme.colors.white,
                minWidth: "100px",
                borderRadius: "3px",
                height: "30px",
                fontSize: "12px",
              }}
              onClick={onClose}
            />
            <Button
              caption={"Save"}
              type="submit"
              isLoading={loading}
              onClick={manageUserOccupants}
              color="white"
              fontSize="12px"
              style={{
                background: theme.gradient.themeGradient,
                color: theme.colors.white,
                minWidth: "100px",
                height: "30px",
                borderRadius: "3px",
              }}
              disabled={data.length == 0}
            />
          </SC.ButtonContainer>

          {!addressBook && (
            <div>
              <Button
                caption="Manage Project Assignment"
                fontSize="12px"
                color="white"
                style={{
                  background: theme.gradient.themeGradient,
                  color: theme.colors.white,
                  minWidth: "100px",
                  borderRadius: "3px",
                  height: "30px",
                  fontSize: "12px",
                }}
                onClick={() => setopenAssignUserDrawer(true)}
              />
            </div>
          )}
        </div>
      </div>
      {userProjectId && (
        <div style={{ padding: "0px 20px 12px 20px" }}>
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontSize: "12px",
              fontWeight: 600,
            }}
          >
            <input
              type="checkbox"
              checked={rootLibraryAccess}
              onChange={(e) => setRootLibraryAccess(e.target.checked)}
              style={{ accentColor: theme.colors.themeColor }}
            />
            Main Library Access
          </label>
        </div>
      )}
      <div
        style={{
          padding: "0px 20px 10px 20px ",
          display: "flex",
          gap: "10px",
          justifyContent: "space-between",
        }}
      >
        <SC.InputContiner>
          <SC.SearchIcon />
          <SC.InputStyle
            placeholder="Search occupant"
            onChange={handleSearch}
          />
        </SC.InputContiner>
        <LevelDropdown
          projectId={userProjectId}
          width="40%"
          onChange={handleChangeLevel}
          allowClear={true}
        />
      </div>
      <div
        style={{ padding: "0px 20px", maxHeight: "72vh", overflowY: "scroll" }}
      >
        {filterData.map((level) => {
          return (
            <>
              <OccupantList
                key={level.levelId}
                levelData={level}
                setSelectedItems={setSelectedItems}
                selectedItems={selectedItems}
                setSearchQuery={setSearchQuery}
                searchQuery={searchQuery}
              />
            </>
          );
        })}
      </div>
      {data.length <= 0 && !loading && (
        <EmptyPage
          message={
            userProjectId ? "No data in project" : "Please select any project"
          }
        />
      )}
      {data.length > 0 && !loading && occupantCount == 0 && (
        <EmptyPage
          message={
            userProjectId ? "No data in project" : "Please select any project"
          }
        />
      )}

      {openAssignUserDrawer && (
        <DetailDrawer
          open={openAssignUserDrawer}
          onClose={closeAssignUserDrawer}
          width={"70%"}
          children={
            <AssignUser
              onClose={closeAssignUserDrawer}
              project={""}
              closeOnSave={true}
              // fetchData={getAlldata}
            />
          }
        />
      )}
    </>
  );
}

export default AssignOccupant;
